import { FeatureFlag } from "../../feature-flags";
import {
  useOnboardingFeatureEnabled,
  type OnboardingFeatureEnabledResult,
} from "../../onboarding/hooks/useOnboardingFeatureEnabled";

/**
 * Composite gate for Work Pattern Import.
 *
 * Requires both `enable-onboarding` and `enable-work-pattern-import`.
 */
export function useWorkPatternImportEnabled(): OnboardingFeatureEnabledResult {
  return useOnboardingFeatureEnabled(FeatureFlag.EnableWorkPatternImport);
}
